import axios from 'axios';

// Use environment variable if set, otherwise use relative URLs (works in production)
// In development with proxy, relative URLs will work through the proxy
// If REACT_APP_API_URL is set, it will override the default
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Fetch all entries
export const fetchEntries = async () => {
  try {
    const response = await api.get('/entries');
    return response.data;
  } catch (error) {
    console.error('Error fetching entries:', error);
    throw error;
  }
};

// Create new entry
export const createEntry = async (entryData) => {
  try {
    const response = await api.post('/entries', entryData);
    return response.data;
  } catch (error) {
    console.error('Error creating entry:', error);
    throw error;
  }
};

// Update existing entry
// Using PUT instead of PATCH for better compatibility with Vercel serverless functions
export const updateEntry = async (id, entryData) => {
  try {
    const response = await api.put(`/entries/${id}`, entryData);
    return response.data;
  } catch (error) {
    console.error('Error updating entry:', error);
    throw error;
  }
};

// Delete entry
export const deleteEntry = async (id) => {
  try {
    const response = await api.delete(`/entries/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting entry:', error);
    throw error;
  }
};

export default api;

